<template>
  <div>
    <v-app-bar
      fixed
      color="white"
      elevate-on-scroll
    >
      <v-row class="align-center">
        <v-col cols="2">
          <v-btn
            icon
            tile
            small
            color="primary"
            class="bg-secondary-50 rounded"
            @click="$router.go(-1)"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="pa-0">
          <v-progress-linear
            background-color="rgba(238, 236, 248, 1)"
            color="#514585"
            v-model="completedTasksPercentage"
            height="16"
            rounded
          >
          <strong>{{ currentPage }} / {{ structTotalPages }}</strong>
          </v-progress-linear>
        </v-col>
        <v-col cols="2">
          <v-btn
              icon
              dark
              tile
              small
              class="bg-primary rounded"
              @click.stop="utilsSidebar"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
    
    <UtilsSidebar />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import UtilsPanelStatic from './UtilsPanelStatic.vue'
import UtilsSidebar from './UtilsSidebar.vue';

export default {
  data: () => ({
    // totalPages: 40,
    utilsNav: false,
    group: null,
  }),
  components: {
    UtilsPanelStatic,
    UtilsSidebar,
},
  computed: {
    ...mapState({
      book: (state) => state.bookReading.book,
      currentStage: (state) => state.bookReading.currentStage,
      currentPage: (state) => state.bookReading.currentPage,
      structTotalPages: (state) => state.bookReading.book.structTotalPages,
    }),
    completedTasksPercentage() {
      if (this.currentPage && this.structTotalPages) {
        return Math.round((this.currentPage / this.structTotalPages) * 100);
      } else {
        return 0;
      }
    }
  },
  watch: {
    group () {
      this.drawer = false
    },
  },
  methods: {
    ...mapActions('bookReading', [
      'increaseCurrentPage',
      'decreaseCurrentPage',
      'setCurrentStage',
    ]),
    closeDrawer() {
      this.utilsNav = !this.utilsNav
    },
    utilsSidebar() {
      this.$root.$emit('closeDrawer')
    },
  },
  mounted() {
    this.$root.$on('closeDrawer', this.closeDrawer)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-progress-linear{
  &.v-progress-linear--rounded{
    outline: 4px solid #EEECF8;;
  }
  &__buffer{
    box-shadow: 0px 0px 8px 0px rgba(45, 28, 120, 0.1) inset;

  }
  &__determinate{
    background: linear-gradient(268.96deg, rgba(255, 255, 255, 0.1) -18.21%, rgba(255, 255, 255, 0) 40.84%), linear-gradient(180deg, rgba(122, 106, 191, 0.7) 0%, rgba(93, 76, 167, 0.7) 29.35%, rgba(100, 82, 174, 0.7) 75.92%, rgba(119, 100, 202, 0.7) 105.9%), linear-gradient(269.63deg, #5746A1 -0.41%, #6051A3 15.72%, #7764CA 31.22%, #5746A1 49.83%, #7764CA 62.86%, #C3BBE7 80.23%, #7865CB 88.91%, #8574D0 105.66%);
    box-shadow: 0px 0px 6px rgba(255, 255, 255, 0.3), inset 0px 0px 10px rgba(238, 236, 248, 0.5);
  }
  .v-progress-linear__content{
    color: #C4BBE7;
  }
}
.v-sheet.v-toolbar.v-app-bar {
  padding-top: 0;
}
</style>